import React from 'react'

import loader from '../../assets/images/loader.svg'

export default class Loader extends React.Component {
	
    render() {
    
        return (
            <div className="layout-loader">
                <img alt="" src={loader} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/core/components/Loader.js